import { Component } from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Grid from 'react-bootstrap/lib/Grid';
import { NOT_FOUND } from 'http-status';

import Section from 'components/Section';
import Breadcrumbs from 'components/Breadcrumbs';
import Notification from 'components/Notification';
import DevTool from 'components/DevTool';
import EmailSubscriptionWidget from 'components/EmailSubscriptionWidget';
import mapStateToProps from './mapStateToProps';
import cn from './styles.local.less';
import * as actions from './actions';
import Footer from '../../Footer';
import NotFound from './NotFound';
import Header from '../Header';
import GDPRBannerContainer from './GDPRBanner';
import { DataLayerScript } from './DataLayerScript';

export { getError, getNotFoundError } from './layoutErrors';

class Layout extends Component {
  static propTypes = {
    Content: elementType,
    breadcrumbProps: PropTypes.object,
    content: PropTypes.any, // DEPRECATED, use Content prop
    children: PropTypes.node,
    extraContent: PropTypes.any,
    error: PropTypes.object,
    headerCmsData: PropTypes.object,
    isLoaded: PropTypes.bool,
    showEmailSubscriptionWidget: PropTypes.bool.isRequired,
    withGdprBanner: PropTypes.bool,
    footerProps: PropTypes.object,
    experiment: PropTypes.object,
    expId: PropTypes.string,
    expVar: PropTypes.string,
  };

  getErrorPage(code) {
    switch (code) {
      case NOT_FOUND: {
        return <NotFound />;
      }

      default: {
        return (
          <div className={cn.error}>
            <h4>{code}</h4>
            <p>Oh! Something went wrong</p>
          </div>
        );
      }
    }
  }

  renderContent() {
    const { Content, content, children, error } = this.props;

    if (error) {
      const { code } = error;

      return this.getErrorPage(code);
    }

    return Content ? <Content /> : children || content;
  }

  renderExtraContent = () => {
    const { extraContent } = this.props;

    return extraContent || null;
  };

  render() {
    const {
      breadcrumbProps,
      headerCmsData,
      isLoaded,
      footerProps,
      showEmailSubscriptionWidget,
      withGdprBanner = true,
      expId,
      expVar,
    } = this.props;

    return isLoaded ? (
      <div>
        <div className="sticky-footer">
          <DataLayerScript />
          <Header cmsData={headerCmsData} />

          {this.renderExtraContent()}
          {withGdprBanner ? <GDPRBannerContainer /> : null}
          <Grid className={cn.grid}>
            {this.renderContent()}

            {breadcrumbProps ? (
              <Section>
                <Breadcrumbs {...breadcrumbProps} />
              </Section>
            ) : null}

            {showEmailSubscriptionWidget ? <EmailSubscriptionWidget /> : null}
          </Grid>
        </div>
        {footerProps && <Footer {...footerProps} />}

        {expId && expVar ? (
          <Helmet>
            <script>
              {`
                  window.expId = "${expId}";
                  window.expVar = "${expVar}";
                `}
            </script>
          </Helmet>
        ) : null}
        <Notification />

        {__LANGUAGE_TOOL__ ? <DevTool /> : null}
      </div>
    ) : null;
  }
}

export default connect(mapStateToProps, actions)(Layout);

export { actions };
